import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    'originPath',
    'fromPathContainer',
  ];

  static outlets = ['checkbox-group'];

  connect() {
    const table = $('#redirect_rules').DataTable();
    table.on('draw.dt', () => {
      if (this.hasCheckboxGroupOutlet) {
        this.checkboxGroupOutlet.unselect();
      }
      $('.redirect-rule__bulk-delete-btn').addClass('hidden');
    });
  }

  duplicateAddOriginPath(event) {
    event.preventDefault();

    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('duplicate_from_path_input');

    wrapperDiv.appendChild(this.#cloneField(this.originPathTarget));
    wrapperDiv.appendChild(this.#createCloseDiv());

    this.fromPathContainerTarget.appendChild(wrapperDiv);
  }

  removeFromPathInput(event) {
    const duplicateFromPathInput = event.target.parentNode.parentNode;
    const nextSibling = duplicateFromPathInput.nextElementSibling;

    duplicateFromPathInput.remove();
    if (nextSibling && nextSibling.tagName === 'SPAN') {
      nextSibling.remove();
    }
  }

  #cloneField(element) {
    const duplicateElement = element.cloneNode(true);
    duplicateElement.value = '';
    duplicateElement.classList.remove('error-border');

    return duplicateElement;
  }

  #createCloseDiv() {
    const closeSpan = document.createElement('span');
    closeSpan.classList.add('material-symbols-outlined', 'remove_from_path_input');
    closeSpan.setAttribute('data-action', 'click->redirects--redirect-rule#removeFromPathInput');
    closeSpan.textContent = 'close';

    const closeDiv = document.createElement('div');
    closeDiv.classList.add('close-icon');
    closeDiv.appendChild(closeSpan);

    return closeDiv;
  } 
}
